// 用于在组件树中传递聊天功能相关的函数和状态

import React, { createContext, useContext, useState } from "react";
import type { Message } from "@/types/chat";

interface ChatContextType {
  append?: (
    message: { content: string; role: "user" | "assistant" },
    options?: { enableTypewriter?: boolean }
  ) => Promise<void>;
  setMessages?: React.Dispatch<React.SetStateAction<Message[]>>;
  activeQuote?: string | null;
  setActiveQuote?: (quote: string | null) => void;
  setStreamingMessageId?: (id: string | undefined) => void;
  previewFile?: (file: {
    url?: string;
    name?: string;
    contentType?: string;
  }) => void;
}

const ChatContext = createContext<ChatContextType>({});

export const useChatContext = () => useContext(ChatContext);

interface ChatProviderProps {
  children: React.ReactNode;
  append?: (
    message: { content: string; role: "user" | "assistant" },
    options?: { enableTypewriter?: boolean }
  ) => Promise<void>;
  setMessages?: React.Dispatch<React.SetStateAction<Message[]>>;
  setStreamingMessageId?: (id: string | undefined) => void;
  previewFile?: (file: {
    url?: string;
    name?: string;
    contentType?: string;
  }) => void;
}

export const ChatProvider: React.FC<ChatProviderProps> = ({
  children,
  append,
  setMessages,
  setStreamingMessageId,
  previewFile,
}) => {
  const [activeQuote, setActiveQuote] = useState<string | null>(null);

  return (
    <ChatContext.Provider
      value={{
        append,
        setMessages,
        activeQuote,
        setActiveQuote,
        setStreamingMessageId,
        previewFile,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
